import React from 'react';

import {type HeaderCells, StorageHeader} from './StorageHeader';

export const StorageList = ({
  children,
  headerCells,
}: {
  children: React.ReactNode;
  headerCells: HeaderCells;
}) => {
  return (
    <div className="mt-0 rounded-b-lg rounded-t-none border-x-0 border-b-0">
      <StorageHeader headerCells={headerCells} />
      {children}
    </div>
  );
};
